/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createPatient = /* GraphQL */ `mutation CreatePatient(
  $input: CreatePatientInput!
  $condition: ModelPatientConditionInput
) {
  createPatient(input: $input, condition: $condition) {
    id
    facilityId
    karteNo
    zipCode
    address
    state
    city
    familyName
    firstName
    familyNameKana
    firstNameKana
    email
    phoneNumber
    dateOfBirth
    gender
    mynumbercard
    seinenhikoukennin
    vip
    memberStatus
    contractState {
      clinicName
      termsAgree
      infoAgree
      __typename
    }
    kaisekiKenriNoKyodaku
    eturankenKyodaku
    tokumeiKakouJouhouHukuseiNoKyodaku
    koukokuUketoriNoKyodaku
    minimumAdvertisedPrice
    designationOfMinimumTransactionPrice
    kouekiKenkyuuMushouRiyou
    houkatuDoui
    torihikiGoui
    tudoKeiyakuKakunin
    lineUserId
    isWalletCreate
    createdAt
    updatedAt
    isLineNotificationEnabled
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePatientMutationVariables,
  APITypes.CreatePatientMutation
>;
export const updatePatient = /* GraphQL */ `mutation UpdatePatient(
  $input: UpdatePatientInput!
  $condition: ModelPatientConditionInput
) {
  updatePatient(input: $input, condition: $condition) {
    id
    facilityId
    karteNo
    zipCode
    address
    state
    city
    familyName
    firstName
    familyNameKana
    firstNameKana
    email
    phoneNumber
    dateOfBirth
    gender
    mynumbercard
    seinenhikoukennin
    vip
    memberStatus
    contractState {
      clinicName
      termsAgree
      infoAgree
      __typename
    }
    kaisekiKenriNoKyodaku
    eturankenKyodaku
    tokumeiKakouJouhouHukuseiNoKyodaku
    koukokuUketoriNoKyodaku
    minimumAdvertisedPrice
    designationOfMinimumTransactionPrice
    kouekiKenkyuuMushouRiyou
    houkatuDoui
    torihikiGoui
    tudoKeiyakuKakunin
    lineUserId
    isWalletCreate
    createdAt
    updatedAt
    isLineNotificationEnabled
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePatientMutationVariables,
  APITypes.UpdatePatientMutation
>;
export const deletePatient = /* GraphQL */ `mutation DeletePatient(
  $input: DeletePatientInput!
  $condition: ModelPatientConditionInput
) {
  deletePatient(input: $input, condition: $condition) {
    id
    facilityId
    karteNo
    zipCode
    address
    state
    city
    familyName
    firstName
    familyNameKana
    firstNameKana
    email
    phoneNumber
    dateOfBirth
    gender
    mynumbercard
    seinenhikoukennin
    vip
    memberStatus
    contractState {
      clinicName
      termsAgree
      infoAgree
      __typename
    }
    kaisekiKenriNoKyodaku
    eturankenKyodaku
    tokumeiKakouJouhouHukuseiNoKyodaku
    koukokuUketoriNoKyodaku
    minimumAdvertisedPrice
    designationOfMinimumTransactionPrice
    kouekiKenkyuuMushouRiyou
    houkatuDoui
    torihikiGoui
    tudoKeiyakuKakunin
    lineUserId
    isWalletCreate
    createdAt
    updatedAt
    isLineNotificationEnabled
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePatientMutationVariables,
  APITypes.DeletePatientMutation
>;
export const createReservation = /* GraphQL */ `mutation CreateReservation(
  $input: CreateReservationInput!
  $condition: ModelReservationConditionInput
) {
  createReservation(input: $input, condition: $condition) {
    id
    patientId
    symptoms
    symptomOthers
    examinationMenuId
    remarks
    dateTime
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReservationMutationVariables,
  APITypes.CreateReservationMutation
>;
export const updateReservation = /* GraphQL */ `mutation UpdateReservation(
  $input: UpdateReservationInput!
  $condition: ModelReservationConditionInput
) {
  updateReservation(input: $input, condition: $condition) {
    id
    patientId
    symptoms
    symptomOthers
    examinationMenuId
    remarks
    dateTime
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateReservationMutationVariables,
  APITypes.UpdateReservationMutation
>;
export const deleteReservation = /* GraphQL */ `mutation DeleteReservation(
  $input: DeleteReservationInput!
  $condition: ModelReservationConditionInput
) {
  deleteReservation(input: $input, condition: $condition) {
    id
    patientId
    symptoms
    symptomOthers
    examinationMenuId
    remarks
    dateTime
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteReservationMutationVariables,
  APITypes.DeleteReservationMutation
>;
export const createObservation = /* GraphQL */ `mutation CreateObservation(
  $input: CreateObservationInput!
  $condition: ModelObservationConditionInput
) {
  createObservation(input: $input, condition: $condition) {
    id
    patientId
    reservationId
    height
    weight
    treatmentOfRecentInjuriesReceived
    purposeOfExamination
    purposeOfExaminationOtherReason
    areaToBeInspected
    jobType
    jobTypeOtherReason
    workplaceTransferMethod
    workplaceTransferMethodOtherReason
    walkingHabit
    aidsForWalking
    createdInHospitalsAndClinics
    insuranceCoverageForOrthoticDevices
    unintentionalWeightLossOfMoreThan2kgInTheLast6Months
    feelingTiredForNoReasonInTheLastTwoWeeks
    lightExerciseForHealthPurposes
    canYouOpenTheLidOfAPlasticBottle
    diseasesRelatedToOrthopedics
    sprainLocation
    fractureLocation
    diseasesRelatedToOrthopedicsOtherReason
    injuries1
    injuries2
    nameOfDrugAllergyMedication
    nameOfMedicationIfAllergicToAnesthesia
    otherAllergies
    otherAllergiesOtherReason
    medicationsCurrentlyBeingTaken
    medicationsCurrentlyBeingTakenOtherReason
    supplementsCurrentlyBeingTaken
    aboutCigarettes
    numberOfCigarettesSmokedDaily
    numberOfYearsSmoked
    aboutAlcohol
    pregnancy
    historyOfChildbirth
    aboutFamilyDoctor
    primaryNursingCareRequirementAuthorization
    footSymptomsOfConcern
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateObservationMutationVariables,
  APITypes.CreateObservationMutation
>;
export const updateObservation = /* GraphQL */ `mutation UpdateObservation(
  $input: UpdateObservationInput!
  $condition: ModelObservationConditionInput
) {
  updateObservation(input: $input, condition: $condition) {
    id
    patientId
    reservationId
    height
    weight
    treatmentOfRecentInjuriesReceived
    purposeOfExamination
    purposeOfExaminationOtherReason
    areaToBeInspected
    jobType
    jobTypeOtherReason
    workplaceTransferMethod
    workplaceTransferMethodOtherReason
    walkingHabit
    aidsForWalking
    createdInHospitalsAndClinics
    insuranceCoverageForOrthoticDevices
    unintentionalWeightLossOfMoreThan2kgInTheLast6Months
    feelingTiredForNoReasonInTheLastTwoWeeks
    lightExerciseForHealthPurposes
    canYouOpenTheLidOfAPlasticBottle
    diseasesRelatedToOrthopedics
    sprainLocation
    fractureLocation
    diseasesRelatedToOrthopedicsOtherReason
    injuries1
    injuries2
    nameOfDrugAllergyMedication
    nameOfMedicationIfAllergicToAnesthesia
    otherAllergies
    otherAllergiesOtherReason
    medicationsCurrentlyBeingTaken
    medicationsCurrentlyBeingTakenOtherReason
    supplementsCurrentlyBeingTaken
    aboutCigarettes
    numberOfCigarettesSmokedDaily
    numberOfYearsSmoked
    aboutAlcohol
    pregnancy
    historyOfChildbirth
    aboutFamilyDoctor
    primaryNursingCareRequirementAuthorization
    footSymptomsOfConcern
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateObservationMutationVariables,
  APITypes.UpdateObservationMutation
>;
export const deleteObservation = /* GraphQL */ `mutation DeleteObservation(
  $input: DeleteObservationInput!
  $condition: ModelObservationConditionInput
) {
  deleteObservation(input: $input, condition: $condition) {
    id
    patientId
    reservationId
    height
    weight
    treatmentOfRecentInjuriesReceived
    purposeOfExamination
    purposeOfExaminationOtherReason
    areaToBeInspected
    jobType
    jobTypeOtherReason
    workplaceTransferMethod
    workplaceTransferMethodOtherReason
    walkingHabit
    aidsForWalking
    createdInHospitalsAndClinics
    insuranceCoverageForOrthoticDevices
    unintentionalWeightLossOfMoreThan2kgInTheLast6Months
    feelingTiredForNoReasonInTheLastTwoWeeks
    lightExerciseForHealthPurposes
    canYouOpenTheLidOfAPlasticBottle
    diseasesRelatedToOrthopedics
    sprainLocation
    fractureLocation
    diseasesRelatedToOrthopedicsOtherReason
    injuries1
    injuries2
    nameOfDrugAllergyMedication
    nameOfMedicationIfAllergicToAnesthesia
    otherAllergies
    otherAllergiesOtherReason
    medicationsCurrentlyBeingTaken
    medicationsCurrentlyBeingTakenOtherReason
    supplementsCurrentlyBeingTaken
    aboutCigarettes
    numberOfCigarettesSmokedDaily
    numberOfYearsSmoked
    aboutAlcohol
    pregnancy
    historyOfChildbirth
    aboutFamilyDoctor
    primaryNursingCareRequirementAuthorization
    footSymptomsOfConcern
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteObservationMutationVariables,
  APITypes.DeleteObservationMutation
>;
export const createReception = /* GraphQL */ `mutation CreateReception(
  $input: CreateReceptionInput!
  $condition: ModelReceptionConditionInput
) {
  createReception(input: $input, condition: $condition) {
    id
    patientId
    date
    outpatientId
    outpatientName
    startTime
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReceptionMutationVariables,
  APITypes.CreateReceptionMutation
>;
export const updateReception = /* GraphQL */ `mutation UpdateReception(
  $input: UpdateReceptionInput!
  $condition: ModelReceptionConditionInput
) {
  updateReception(input: $input, condition: $condition) {
    id
    patientId
    date
    outpatientId
    outpatientName
    startTime
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateReceptionMutationVariables,
  APITypes.UpdateReceptionMutation
>;
export const deleteReception = /* GraphQL */ `mutation DeleteReception(
  $input: DeleteReceptionInput!
  $condition: ModelReceptionConditionInput
) {
  deleteReception(input: $input, condition: $condition) {
    id
    patientId
    date
    outpatientId
    outpatientName
    startTime
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteReceptionMutationVariables,
  APITypes.DeleteReceptionMutation
>;
export const createContract = /* GraphQL */ `mutation CreateContract(
  $input: CreateContractInput!
  $condition: ModelContractConditionInput
) {
  createContract(input: $input, condition: $condition) {
    id
    clinicName
    isMedical
    medicalTreatment {
      title
      detail
      __typename
    }
    infoAgree
    termsAndConditions
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateContractMutationVariables,
  APITypes.CreateContractMutation
>;
export const updateContract = /* GraphQL */ `mutation UpdateContract(
  $input: UpdateContractInput!
  $condition: ModelContractConditionInput
) {
  updateContract(input: $input, condition: $condition) {
    id
    clinicName
    isMedical
    medicalTreatment {
      title
      detail
      __typename
    }
    infoAgree
    termsAndConditions
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateContractMutationVariables,
  APITypes.UpdateContractMutation
>;
export const deleteContract = /* GraphQL */ `mutation DeleteContract(
  $input: DeleteContractInput!
  $condition: ModelContractConditionInput
) {
  deleteContract(input: $input, condition: $condition) {
    id
    clinicName
    isMedical
    medicalTreatment {
      title
      detail
      __typename
    }
    infoAgree
    termsAndConditions
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteContractMutationVariables,
  APITypes.DeleteContractMutation
>;
export const createNotification = /* GraphQL */ `mutation CreateNotification(
  $input: CreateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  createNotification(input: $input, condition: $condition) {
    id
    patientId
    facilityId
    patientIdFacilityId
    createdAt
    altText
    title
    message
    notificationType
    buttonType
    actionType
    actionValue
    choices
    isRead
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNotificationMutationVariables,
  APITypes.CreateNotificationMutation
>;
export const updateNotification = /* GraphQL */ `mutation UpdateNotification(
  $input: UpdateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  updateNotification(input: $input, condition: $condition) {
    id
    patientId
    facilityId
    patientIdFacilityId
    createdAt
    altText
    title
    message
    notificationType
    buttonType
    actionType
    actionValue
    choices
    isRead
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNotificationMutationVariables,
  APITypes.UpdateNotificationMutation
>;
export const deleteNotification = /* GraphQL */ `mutation DeleteNotification(
  $input: DeleteNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  deleteNotification(input: $input, condition: $condition) {
    id
    patientId
    facilityId
    patientIdFacilityId
    createdAt
    altText
    title
    message
    notificationType
    buttonType
    actionType
    actionValue
    choices
    isRead
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNotificationMutationVariables,
  APITypes.DeleteNotificationMutation
>;
export const createRetryNotifications = /* GraphQL */ `mutation CreateRetryNotifications(
  $input: CreateRetryNotificationsInput!
  $condition: ModelRetryNotificationsConditionInput
) {
  createRetryNotifications(input: $input, condition: $condition) {
    id
    sendMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRetryNotificationsMutationVariables,
  APITypes.CreateRetryNotificationsMutation
>;
export const updateRetryNotifications = /* GraphQL */ `mutation UpdateRetryNotifications(
  $input: UpdateRetryNotificationsInput!
  $condition: ModelRetryNotificationsConditionInput
) {
  updateRetryNotifications(input: $input, condition: $condition) {
    id
    sendMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRetryNotificationsMutationVariables,
  APITypes.UpdateRetryNotificationsMutation
>;
export const deleteRetryNotifications = /* GraphQL */ `mutation DeleteRetryNotifications(
  $input: DeleteRetryNotificationsInput!
  $condition: ModelRetryNotificationsConditionInput
) {
  deleteRetryNotifications(input: $input, condition: $condition) {
    id
    sendMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRetryNotificationsMutationVariables,
  APITypes.DeleteRetryNotificationsMutation
>;
export const createFacilityPatients = /* GraphQL */ `mutation CreateFacilityPatients(
  $input: CreateFacilityPatientsInput!
  $condition: ModelFacilityPatientsConditionInput
) {
  createFacilityPatients(input: $input, condition: $condition) {
    facilityId
    patientId
    lineUserId
    karteNo
    vip
    isFirstVisit
    memberStatus
    createdAt
    updatedAt
    lineUserId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFacilityPatientsMutationVariables,
  APITypes.CreateFacilityPatientsMutation
>;
export const updateFacilityPatients = /* GraphQL */ `mutation UpdateFacilityPatients(
  $input: UpdateFacilityPatientsInput!
  $condition: ModelFacilityPatientsConditionInput
) {
  updateFacilityPatients(input: $input, condition: $condition) {
    facilityId
    patientId
    lineUserId
    karteNo
    vip
    isFirstVisit
    memberStatus
    createdAt
    updatedAt
    lineUserId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFacilityPatientsMutationVariables,
  APITypes.UpdateFacilityPatientsMutation
>;
export const deleteFacilityPatients = /* GraphQL */ `mutation DeleteFacilityPatients(
  $input: DeleteFacilityPatientsInput!
  $condition: ModelFacilityPatientsConditionInput
) {
  deleteFacilityPatients(input: $input, condition: $condition) {
    facilityId
    patientId
    lineUserId
    karteNo
    vip
    isFirstVisit
    memberStatus
    createdAt
    updatedAt
    lineUserId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFacilityPatientsMutationVariables,
  APITypes.DeleteFacilityPatientsMutation
>;
